//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "InvoiceSectionPanel",
    props: {
        // ----- Quotation -----
        salesOrderId: { type: [Number, String], default: "" },
        // ชื่อลูกค้าจาก quotation ที่เลือก (แสดงอย่างเดียว)
        customerName: { type: String, default: "" },
        price: { type: [Number, String], default: "" },
        // สกุลเงินจาก quotation ที่เลือก (แสดงอย่างเดียว)
        currency: { type: String, default: "" },
        salesOrderList: { type: Array, default: () => [] },

        // ----- Invoice -----
        // invoice ที่เลือกใน dropdown การ์ด 1 (ใช้กับ .sync)
        invoiceId: { type: [Number, String], default: "" },
        // invoice ทั้งหมดของบริษัท → ตัวเลือกใน dropdown การ์ด 1
        invoiceSelectList: { type: Array, default: () => [] },
        // invoice ที่ผูกกับคดีนี้ → รายการในการ์ด 2
        invoiceList: { type: Array, default: () => [] },

        // แสดงแถวเลือก Invoice ในการ์ด 1 หรือไม่ (หน้า View ส่ง false เพื่อซ่อน)
        showInvoiceSelect: { type: Boolean, default: true },

        sectionLabel: { type: String, default: "E · การเงิน & สถานะ Invoice" },
        readonly: { type: Boolean, default: false },
    },
    computed: {
        hasInvoice() {
            return Array.isArray(this.invoiceList) && this.invoiceList.length > 0;
        },
        hasInvoiceSelect() {
            return Array.isArray(this.invoiceSelectList) && this.invoiceSelectList.length > 0;
        },
        invoicePlaceholder() {
            return this.hasInvoiceSelect ? "— เลือก Invoice —" : "ยังไม่มี Invoice";
        },
        // object ของ invoice ที่เลือกอยู่ (ค้นจาก list เอง ใช้ได้ทั้งตอนเลือกใหม่และตอนโหลดค่าเดิม)
        // เทียบเป็น string เพราะ inv_id_preview อาจมาเป็น "1786" หรือ 1786
        selectedInvoice() {
            if (this.invoiceId === "" || this.invoiceId === null || this.invoiceId === undefined) return null;
            return (
                this.invoiceSelectList.find(
                    (item) => String(item.inv_id_preview) === String(this.invoiceId)
                ) || null
            );
        },
    },
    methods: {
        onSelectSO(value) {
            // ส่งทั้ง value (สำหรับ .sync) และ object เต็มของ quotation ที่เลือก
            // ให้ parent เอาไปคำนวณ price / เก็บ status เองได้ ไม่ต้องไปค้นซ้ำ
            this.$emit("update:salesOrderId", value);
            const selected = this.salesOrderList.find((item) => item.quotation_id === value) || null;
            this.$emit("select-so", selected);
        },
        onSelectInvoice(value) {
            // แบบเดียวกับ Quotation: value สำหรับ .sync + object เต็มสำหรับ parent
            // clearable ส่ง null มา → แปลงเป็น "" ให้ตรงกับค่า default
            const id = value === null || value === undefined ? "" : value;
            this.$emit("update:invoiceId", id);
            const selected =
                this.invoiceSelectList.find((item) => String(item.inv_id_preview) === String(id)) || null;
            this.$emit("select-invoice", selected);
        },
    },
};
